import { render } from "./SideBarComponent.vue?vue&type=template&id=55da10f4&scoped=true"
import script from "./SideBarComponent.vue?vue&type=script&lang=js"
export * from "./SideBarComponent.vue?vue&type=script&lang=js"

import "./SideBarComponent.vue?vue&type=style&index=0&id=55da10f4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55da10f4"]])

export default __exports__